window.IntlTelInputInterop = (() => {
  const _cleanNumber = (value) => value !== null ? value.replace(/\D/g, '') : value;
  const _formatNational = (iti, fallback) => iti.isValidNumber()
    ? intlTelInputUtils.formatNumber(iti.getNumber(), iti.getSelectedCountryData().iso2, intlTelInputUtils.numberFormat.NATIONAL)
    : fallback;
  const _formatInternational = (iti, fallback) => iti.isValidNumber()
    ? iti.getNumber()
    : _cleanNumber(fallback);

  return {
    init(inputElement, displayElement, countryElement, dotNetReference) {
      const iti = intlTelInput(displayElement, {
        dropdownContainer: document.body,
        nationalMode: true,
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17/build/js/utils.js"
      });
      displayElement.value = _formatNational(iti, displayElement.value);
      if (countryElement.value)
        iti.setCountry(countryElement.value.toLowerCase());
      else {
        countryElement.value = iti.getSelectedCountryData().iso2.toUpperCase();
        dotNetReference.invokeMethodAsync('ClientCountryChanged', countryElement.value);
      }

      const handleChange = () => {
        displayElement.value = _formatNational(iti, displayElement.value);
        inputElement.value = _formatInternational(iti, displayElement.value);
        dotNetReference.invokeMethodAsync('ClientNumberChanged', inputElement.value);
      }

      displayElement.addEventListener('input', handleChange);
      displayElement.addEventListener('change', handleChange);
      displayElement.addEventListener('countrychange', () => {
        countryElement.value = iti.getSelectedCountryData().iso2.toUpperCase();
        dotNetReference.invokeMethodAsync('ClientCountryChanged', countryElement.value);
      })
      countryElement.addEventListener('change', () => iti.setCountry(this.value.toLowerCase()));
    },
    destroy(displayElement) {
      intlTelInputGlobals.getInstance(displayElement).destroy();
    }
  }
})();